import React, { useCallback } from "react";
import {
  AHIcon,
  AHText,
  Box,
  Circle,
  TouchableBox,
  useLayoutContext,
} from "arkh";
import { FlatList } from "react-native-gesture-handler";
import Animated, {
  SharedValue,
  interpolate,
  useAnimatedStyle,
} from "react-native-reanimated";

export function TodoBottomSheetTitleSuggestions(props: {
  suggestions: readonly { readonly title: string }[];
  setTitle: (title: string) => void;
  height: number;
  inputExpanded: SharedValue<number>;
  showSuggestions: SharedValue<0 | 1>;
  mode: "edit" | "create";
}) {
  const layout = useLayoutContext();
  const renderItem = useCallback(
    ({ item }: { item: (typeof props.suggestions)[number] }) => {
      return (
        <TouchableBox
          style={{
            height: props.height,
            justifyContent: "center",
            marginRight: layout.space.small,
          }}
          onPress={() => {
            props.setTitle(item.title);
          }}
        >
          <Box
            color="surface-background"
            borderColor="border-primary"
            style={{
              borderRadius: layout.circle.medium,
              justifyContent: "center",
              paddingRight: layout.circle.medium / 2,
              height: layout.circle.medium,
              borderWidth: 1,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Circle
              size="smallMedium"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <AHIcon type="suggestion" color="blue-light" size="xsmall" />
            </Circle>
            <AHText>{item.title}</AHText>
          </Box>
        </TouchableBox>
      );
    },
    [layout.circle.medium, layout.space.small, props]
  );

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: props.showSuggestions.value,
      left:
        props.mode === "edit"
          ? 0
          : interpolate(
              props.inputExpanded.value,
              [0, 1],
              [layout.circle.large + layout.space.medium, 0]
            ),
    };
  });

  return (
    <Animated.View
      style={[
        {
          position: "absolute",
          bottom: 0,
          right: 0,
          height: props.height,
        },
        animatedStyle,
      ]}
    >
      <FlatList
        horizontal
        style={{
          flex: 1,
        }}
        contentContainerStyle={{
          paddingHorizontal: layout.space.medium,
          height: props.height,
          alignItems: "center",
        }}
        keyExtractor={(item) => item.title}
        data={props.suggestions}
        renderItem={renderItem}
        showsHorizontalScrollIndicator={false}
      />
    </Animated.View>
  );
}
